import { ArrowUpRight } from "lucide-react";
import { services, WA_DEMO } from "../../lib/site";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";
import { Sparkle } from "./Sparkle";

export const Services = () => (
  <section id="services" data-testid="services-section" className="relative py-24 sm:py-32 bg-panel/30 border-y hairline scroll-mt-20" aria-label="Services">
    <Sparkle className="absolute top-10 right-[8%]" size={16} />
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <SectionHeading
        eyebrow="What We Do"
        lines={[<>Everything your business</>, <>needs to <em className="italic text-brand">win online.</em></>]}
        className="mb-14"
      />

      <div className="grid sm:grid-cols-2 gap-5">
        {services.map((s, i) => (
          <Reveal key={s.title} delay={0.08 * i}>
            <article
              data-testid={`service-card-${s.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="group relative h-full bg-ink border hairline p-8 sm:p-10 card-lift overflow-hidden"
            >
              <span className="absolute -top-4 right-6 font-display font-light text-[7rem] leading-none text-white/[0.04] select-none" aria-hidden="true">
                {s.num}
              </span>
              <div className="relative">
                <div className="w-12 h-12 border border-brand/40 flex items-center justify-center text-brand group-hover:bg-brand group-hover:text-ink transition-all duration-500">
                  <s.icon size={20} strokeWidth={1.6} />
                </div>
                <p className="font-mono text-[10px] tracking-[0.3em] text-brand mt-7 uppercase">{s.num}</p>
                <h3 className="font-display text-2xl sm:text-3xl text-white font-medium mt-2">{s.title}</h3>
                <p className="mt-3 text-mute text-sm sm:text-base leading-relaxed max-w-sm">{s.desc}</p>
                <a
                  data-testid={`service-cta-${i}`}
                  href={WA_DEMO}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-6 inline-flex items-center gap-2 text-xs font-semibold tracking-widest uppercase text-white/70 group-hover:text-brand transition-colors duration-300"
                >
                  Start a project <ArrowUpRight size={13} />
                </a>
              </div>
            </article>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.15}>
        <p className="mt-10 text-center text-mute text-sm" data-testid="services-trust-line">
          Not sure what you need? <a href={WA_DEMO} target="_blank" rel="noopener noreferrer" className="text-brand underline underline-offset-4 decoration-brand/40 hover:decoration-brand">Get a free demo</a> and see what fits — no advance until you approve.
        </p>
      </Reveal>
    </div>
  </section>
);
